<header>
  <ng-container *ngIf="(journeySettings$ | async); let settings">
    <ng-container *ngIf="settings.logo; let logo">
      <ng-container *ngIf="settings.website; else justLogo">
        <a [href]="settings.website" target="_blank" class="flex-box">
          <img [src]="logo" alt="logo" class="img-logo" />
        </a>
      </ng-container>
      <ng-template #justLogo>
        <img [src]="logo" alt="logo" class="img-logo" />
      </ng-template>
    </ng-container>
  </ng-container>
  <div class="flex-box-center ml-auto">
    <p class="text-size-8 whitespace-nowrap">Powered by</p>
    <img src="/assets/images/svg/fello.svg" alt="fello" class="img-fello ml-1" />
  </div>
  <div class="progress-c">
    <span class="progress" [style]="'width:' + progressPerc + '%'"></span>
  </div>
</header>
